import React from "react";
import { Card, CardBody, Container } from "reactstrap";
import { Box, Skeleton, Grid } from "@mui/material";
import BackgroundImage from "../../assets/backgrounds/Background.svg";

const DashboardSkeleton: React.FC = () => {
  const isDark = localStorage.getItem("theme") === "dark";
  return (
    <div
      className="user-chat w-100 overflow-x-hidden"
      style={{
        height: "100vh",
        backgroundColor: isDark ? "#141414" : "#f7f7f7",
        backgroundImage: isDark ? "none" : `url(${BackgroundImage})`,
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
      }}
    >
      <div className="max-card-area">
        <Container
          style={{ maxWidth: "50em", marginTop: "5em" }}
          className="card-status d-flex flex-column"
        >
          <Card
            className="big-card container-card"
            style={
              isDark
                ? {
                    backgroundColor: "rgba(20, 20, 20, 0.98)",
                    border: "1px solid rgba(255,255,255,0.08)",
                  }
                : {}
            }
          >
            <CardBody style={isDark ? { backgroundColor: "transparent" } : {}}>
              {/* JessPage Skeleton */}
              <Box sx={{ maxWidth: "xl", width: "100%" }}>
                <Grid container justifyContent="center">
                  <Grid size={{ xs: 12 }}>
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: { xs: "100%", md: "40.13rem" },
                        mx: "auto",
                        boxShadow: 3,
                        borderRadius: "16px",
                        backgroundColor: isDark
                          ? "rgba(20,20,20,0.98)"
                          : "#fff",
                        mb: 3,
                        p: 3,
                      }}
                    >
                      {/* Avatar and Status */}
                      <Box
                        sx={{ display: "flex", alignItems: "center", mb: 3 }}
                      >
                        <Skeleton variant="circular" width={80} height={80} />
                        <Box sx={{ ml: 2, flex: 1 }}>
                          <Skeleton variant="text" width={120} height={32} />
                          <Skeleton
                            variant="text"
                            width={180}
                            height={24}
                            sx={{ mt: 1 }}
                          />
                        </Box>
                        <Skeleton
                          variant="rectangular"
                          width={120}
                          height={40}
                          sx={{ borderRadius: 2 }}
                        />
                      </Box>

                      {/* Phone Number */}
                      <Skeleton
                        variant="text"
                        width={200}
                        height={24}
                        sx={{ mx: "auto" }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              {/* StatusPage Skeleton */}
              <Box sx={{ maxWidth: "xl", width: "100%", mt: 3 }}>
                <Box>
                  {/* Header */}
                  <Box sx={{ mb: 3, textAlign: "center" }}>
                    <Skeleton
                      variant="text"
                      width={300}
                      height={40}
                      sx={{ mx: "auto" }}
                    />
                  </Box>

                  {/* Search Bar */}
                  <Box sx={{ mb: 3 }}>
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height={56}
                      sx={{ borderRadius: 2 }}
                    />
                  </Box>

                  {/* Session Cards */}
                  {[1, 2, 3].map((index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 2,
                        p: 2,
                        borderRadius: 2,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        backgroundColor: isDark
                          ? "rgba(30,30,30,0.95)"
                          : "#fff",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Skeleton variant="circular" width={48} height={48} />
                          <Box>
                            <Skeleton variant="text" width={120} height={24} />
                            <Skeleton variant="text" width={180} height={20} />
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Skeleton
                            variant="rectangular"
                            width={100}
                            height={32}
                            sx={{ borderRadius: 1 }}
                          />
                          <Skeleton variant="circular" width={32} height={32} />
                        </Box>
                      </Box>
                    </Box>
                  ))}

                  {/* Add Button */}
                  <Box
                    sx={{ mt: 3, display: "flex", justifyContent: "center" }}
                  >
                    <Skeleton
                      variant="rectangular"
                      width={200}
                      height={48}
                      sx={{ borderRadius: 24 }}
                    />
                  </Box>
                </Box>
              </Box>
            </CardBody>
          </Card>
        </Container>
      </div>

      {/* Fixed Icon Skeleton */}
      <Box sx={{ position: "fixed", bottom: 20, right: 20 }}>
        <Skeleton variant="circular" width={60} height={60} />
      </Box>
    </div>
  );
};

export default DashboardSkeleton;
